module.exports = __webpack_public_path__ + "img/linkedin.25952777.svg";